if (!customElements.get('site-header')) {
  customElements.define('site-header', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        this.clearProductTimers();
        const open = event.target.closest('details[open]');
        if (open && this.contains(open)) {
          open.open = false;
          open.querySelector('summary')?.focus();
          event.stopPropagation();
        }
      }, options);
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeMenus();
      }, options);
      this.addEventListener('focusout', (event) => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closeMenus();
      }, options);
      this.addEventListener('click', (event) => {
        if (event.target.closest('a')) this.closeMenus();
      }, options);
      const topMenus = '.site-header__links > li > details, .site-header__mobile';
      this.querySelectorAll(topMenus).forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          this.clearProductTimers();
          this.querySelectorAll(topMenus).forEach((other) => {
            if (other !== details) other.open = false;
          });
        }, options);
      });
      this.breakpoint = matchMedia('(min-width: 1100px)');
      this.breakpoint.addEventListener('change', () => this.closeMenus(), options);
      this.setupProductMenu(options);
      this.addEventListener('shopify:block:select', (event) => {
        const preview = event.target.closest('[data-product-preview]');
        if (!preview) return;
        const menu = preview.closest('[data-products-menu]');
        menu.open = true;
        this.activateProductCategory(menu, preview.dataset.productPreview);
      }, options);
      this.resizeObserver = new ResizeObserver(() => {
        this.updateNavigation();
        document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
      });
      this.resizeObserver.observe(this);
      document.fonts.ready.then(() => {
        if (this.isConnected) this.updateNavigation();
      });
    }

    updateNavigation() {
      this.removeAttribute('data-overflow');
      const navigation = this.querySelector('.site-header__desktop');
      if (navigation && this.breakpoint.matches && navigation.scrollWidth > navigation.clientWidth + 1) {
        this.setAttribute('data-overflow', '');
      }
    }

    closeMenus() {
      this.clearProductTimers();
      this.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
    }

    setupProductMenu(options) {
      const menu = this.querySelector('[data-products-menu]');
      if (!menu) return;
      const canHover = (event) => event.pointerType === 'mouse' && this.breakpoint.matches && !this.hasAttribute('data-overflow');
      menu.addEventListener('pointerenter', (event) => {
        if (!canHover(event)) return;
        clearTimeout(this.productCloseTimer);
        if (!menu.open) this.productOpenTimer = setTimeout(() => { menu.open = true; }, 320);
      }, options);
      menu.addEventListener('pointerleave', (event) => {
        if (!canHover(event)) return;
        clearTimeout(this.productOpenTimer);
        clearTimeout(this.productCategoryTimer);
        this.productCloseTimer = setTimeout(() => {
          if (!menu.querySelector(':focus-visible')) menu.open = false;
        }, 320);
      }, options);
      menu.querySelector('summary').addEventListener('click', () => this.clearProductTimers(), options);
      menu.querySelectorAll('[data-product-category]').forEach((category) => {
        category.addEventListener('pointerenter', (event) => {
          if (!canHover(event)) return;
          clearTimeout(this.productCategoryTimer);
          this.productCategoryTimer = setTimeout(() => this.activateProductCategory(menu, category.dataset.productCategory), 160);
        }, options);
        category.addEventListener('pointerleave', () => clearTimeout(this.productCategoryTimer), options);
        category.addEventListener('focus', () => {
          clearTimeout(this.productCategoryTimer);
          this.activateProductCategory(menu, category.dataset.productCategory);
        }, options);
      });
    }

    activateProductCategory(menu, categoryId) {
      menu.querySelectorAll('[data-product-category]').forEach((category) => {
        category.classList.toggle('is-active', category.dataset.productCategory === categoryId);
      });
      menu.querySelectorAll('[data-product-preview]').forEach((preview) => {
        preview.hidden = preview.dataset.productPreview !== categoryId;
      });
    }

    clearProductTimers() {
      clearTimeout(this.productOpenTimer);
      clearTimeout(this.productCloseTimer);
      clearTimeout(this.productCategoryTimer);
    }

    disconnectedCallback() {
      this.clearProductTimers();
      this.controller?.abort();
      this.resizeObserver?.disconnect();
    }
  });
}
